import { ActionReducer } from '@ngrx/store';
import { StateManagementHelpers } from '../../helpers';
import * as CreateAccountActions from '../actions/create-account.actions';
import { ICreateAccountStore } from '../interfaces/create-account-store.interface';

const defaultCreateAccountStore: ICreateAccountStore = {
  registeredCompanyName: '',
  clientNumber: '',
  firstName: '',
  lastName: '',
  email: '',
  code: '',
  heardAboutUsId: -1,
  howDidYouHearAboutUs: '',
  heardAboutUsDetails: '',
  mobilePhoneNumber: '',
  businessPhoneNumber: '',
};

export const createAccountReducer: ActionReducer<
  ICreateAccountStore | undefined,
  any
> = (
  // eslint-disable-next-line default-param-last
  state: ICreateAccountStore = defaultCreateAccountStore,
  action: any,
): ICreateAccountStore | undefined => {
  switch (action.type) {
    case CreateAccountActions.TELL_US_ABOUT_YOURSELF:
      return StateManagementHelpers.mergeState(state, {
        registeredCompanyName: action.registeredCompanyName,
        firstName: action.firstName,
        lastName: action.lastName,
        email: action.email,
        heardAboutUsId: action.heardAboutUsId,
        howDidYouHearAboutUs: action.howDidYouHearAboutUs,
        heardAboutUsDetails: action.heardAboutUsDetails,
      }) as ICreateAccountStore;
    case CreateAccountActions.MOBILE_IDENTITY:
      return StateManagementHelpers.mergeState(state, {
        mobilePhoneNumber: action.mobilePhoneNumber,
        businessPhoneNumber: action.businessPhoneNumber,
      }) as ICreateAccountStore;
    case CreateAccountActions.CHANGE_MOBILE:
      return StateManagementHelpers.mergeState(state, {
        mobilePhoneNumber: action.mobilePhoneNumber,
      }) as ICreateAccountStore;
    case CreateAccountActions.CHANGE_BUSINESS:
      return StateManagementHelpers.mergeState(state, {
        businessPhoneNumber: action.businessPhoneNumber,
      }) as ICreateAccountStore;
    case CreateAccountActions.CHANGE_EMAIL:
      return StateManagementHelpers.mergeState(state, {
        email: action.email,
      }) as ICreateAccountStore;
    case CreateAccountActions.CODE_IDENTITY:
      return StateManagementHelpers.mergeState(state, {
        code: action.code,
      }) as ICreateAccountStore;
    case CreateAccountActions.CLIENT_NUMBER:
      return StateManagementHelpers.mergeState(state, {
        clientNumber: action.clientNumber,
      }) as ICreateAccountStore;
    case CreateAccountActions.LEGACY_UPGRADE:
      return StateManagementHelpers.mergeState(state, {
        registeredCompanyName: action.registeredCompanyName,
        heardAboutUsId: action.heardAboutUsId,
        howDidYouHearAboutUs: action.howDidYouHearAboutUs,
        heardAboutUsDetails: action.heardAboutUsDetails,
      }) as ICreateAccountStore;
    case CreateAccountActions.LOGIN:
      return StateManagementHelpers.mergeState(state, {
        firstName: action.firstName,
        lastName: action.lastName,
        email: action.email,
      }) as ICreateAccountStore;
    case CreateAccountActions.ALL:
      return StateManagementHelpers.mergeState(state, {
        registeredCompanyName: action.registeredCompanyName,
        firstName: action.firstName,
        lastName: action.lastName,
        email: action.email,
        code: action.code,
        heardAboutUsId: action.heardAboutUsId,
        howDidYouHearAboutUs: action.howDidYouHearAboutUs,
        heardAboutUsDetails: action.heardAboutUsDetails,
        mobilePhoneNumber: action.mobilePhoneNumber,
        businessPhoneNumber: action.businessPhoneNumber,
      }) as ICreateAccountStore;
    default:
      return state;
  }
};
